// material-ui
import { useTheme } from '@mui/material/styles';
import React, { useState, useEffect } from 'react';

import {
  Grid,
  Typography,
  Alert,
  Backdrop,
  CircularProgress
} from '@mui/material';


// project imports
import SubCard from 'src/components/cards/SubCard';
import ThemeCustomization from 'src/themesNew';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import axios from 'src/utils/axios';
import { makeStyles } from '@material-ui/styles';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';


// ==============================|| PROFILE 1 - CHANGE PASSWORD ||============================== //

const Experience = ({ EmployeeNr }) => {
  const theme = useTheme();

  if (EmployeeNr === 0) {
    return <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <Alert variant="outlined" severity="error" sx={{ borderColor: theme.palette.warning.dark }}>
          <Typography variant='h5' style={{ color: 'red' }}>Önce Kayıt İşlemini Tamamlamanız Gerekli!....
          </Typography>
        </Alert>      </Grid>
    </Grid>
  };
  const [historyData, setHistoryData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const itemsPerPage = 10;
  const useStyles = makeStyles(() => ({
    ul: {
      '& .MuiPaginationItem-root': {
        '&.Mui-selected': {
          background: '#FF9800',
          color: 'white',
          borderRadius: '50%',
        },
      },
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }));
  const classes = useStyles();
  const uniqueEntries = {};
  useEffect(() => {
    setLoading(true);
    axios.get(`GetEmplayeeHistory/${EmployeeNr}`).then((response) => {
      setLoading(false);
      if (response?.data.length > 0) {
        var Data = [];
        // Yıl bazında tekilleştirilmiş verileri tutacak bir Map oluşturuyoruz.
        response.data.forEach((item) => {
          var Deger = { calisanTipi: item.calisanTipi, ORGANIZASYON: item.ORGANIZASYON, YIL: item.YIL };
          Data.push(Deger);
        });
        Data.sort((a, b) => b.YIL - a.YIL);
        const newData = Data.map((item, index) => {
          const nextAge = Data[index + 1] ? Data[index + 1].YIL : 0;
          return {
            ...item,
            nextYIL: nextAge,
          };
        });
        // setHistoryData(newData);
        const getKey = (item) => `${item.calisanTipi}_${item.ORGANIZASYON}_${item.YIL}`;

        // Group the data by the unique key
        const groupedData = newData.reduce((acc, item) => {
          const key = getKey(item);
          if (!acc.has(key)) {
            acc.set(key, item);
          }
          return acc;
        }, new Map());

        // Get the distinct items from the grouped data
        const distinctData = Array.from(groupedData.values());

        setHistoryData(distinctData);
      } else {
        setHistoryData([]);
      }
    });
  }, []);



  const uniqueData = Object.values(uniqueEntries);
  return (
    <div>
      {
        loading ?
          <Backdrop className={classes.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : <div></div>
      }
      <ThemeCustomization>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SubCard title={'Tecrübe'} style={{ minHeight: 400, maxHeight: 400, overflowY: 'auto' }}>
                <Timeline position="alternate">
                  {historyData?.map((item) => (
                    <TimelineItem key={item.id}>
                      <TimelineOppositeContent color="text.secondary">
                        {item.nextYIL + ' - ' + item.YIL}
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot sx={{
                          backgroundColor: '#FF9800'
                        }} />
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent>
                        {item.ORGANIZASYON + ' '}<b>{item.calisanTipi}</b>
                      </TimelineContent>
                    </TimelineItem>
                  ))}
                </Timeline>
              </SubCard>
            </Grid>
          </Grid>

        </LocalizationProvider>
      </ThemeCustomization >
    </div>
  );
};

export default Experience;
